/** 分片 / 动态 import 加载失败时用于自动刷新重试（缓解 CDN 抖动、网络切换等） */
const STORAGE_KEY = '__yz_chunk_load_retry';
const MAX_ATTEMPTS = 3;
const WINDOW_MS = 45_000;

type RetryPayload = { a: number; t: number };

function readPayload(): RetryPayload {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return { a: 0, t: Date.now() };
    const o = JSON.parse(raw) as Partial<RetryPayload>;
    return { a: Number(o.a) || 0, t: Number(o.t) || Date.now() };
  } catch {
    return { a: 0, t: Date.now() };
  }
}

function writePayload(p: RetryPayload) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(p));
  } catch {
    /* 隐私模式等 */
  }
}

/** 是否在「时间窗」内仍允许自动整页刷新重试 */
export function willChunkLoadAutoReload(): boolean {
  let { a, t } = readPayload();
  if (Date.now() - t > WINDOW_MS) {
    a = 0;
    t = Date.now();
  }
  return a < MAX_ATTEMPTS;
}

/** 记一次重试并刷新页面 */
export function triggerChunkLoadAutoReload(): void {
  let { a, t } = readPayload();
  if (Date.now() - t > WINDOW_MS) {
    a = 0;
    t = Date.now();
  }
  if (a >= MAX_ATTEMPTS) return;
  writePayload({ a: a + 1, t });
  window.location.reload();
}

export function isChunkLoadError(err: unknown): boolean {
  if (err == null) return false;
  const any = err as { name?: string; message?: string };
  const name = String(any?.name ?? '');
  const message = String(any?.message ?? err);
  return (
    name === 'ChunkLoadError' ||
    /Loading chunk [\w.-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    (/dynamically imported module/i.test(message) && /fail/i.test(message))
  );
}

/** 路由正常切换后调用，避免旧的重试计数影响后续浏览 */
export function clearChunkLoadRetryState(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
